import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './RadioBtnGroup.sass';
import { SIZE } from '../../constants';
export { SIZE };
export class RadioBtnGroup extends React.PureComponent {
    static count = 0;
    id = '';
    constructor(props) {
        super(props);
        this.id = 'TmRadioBtnGroup' + ++RadioBtnGroup.count; // unique ID for DOM
    }
    render() {
        const className = this.props.size === SIZE.SML ? ' sg-btnGroup-sml' : ' sg-btnGroup-med';
        return (_jsxs("div", { className: 'sg-btnGroup' + className, children: [this.props.items.map((item, index) => (_jsx("input", { id: `${this.id}-${item.value}`, type: 'radio', name: this.id, value: item.value, checked: this.props.value !== undefined ? item.value === this.props.value : undefined, 
                    /* Pokud neni definovano je automaticky vybrana 1. polozka */
                    defaultChecked: this.props.value === undefined ? index === 0 : undefined, onChange: this.props.onChange, "data-test-id": this.props.testId ? `${this.props.testId}-input-${index + 1}` : undefined }, item.value))), this.props.items.map((item, index) => {
                    const btnClassName = item.isHovered ? ' sg-btnGroup--btn-isHovered' : '';
                    return (_jsxs("label", { className: 'sg-btnGroup--btn' + btnClassName, htmlFor: `${this.id}-${item.value}`, "data-test-id": this.props.testId ? `${this.props.testId}-item-${index + 1}` : undefined, children: [_jsx("span", { children: item.label }), " "] }, item.value));
                })] }));
    }
}
//# sourceMappingURL=RadioBtnGroup.js.map